export class RedefinirSenhaFormModel {
    constructor(
        public email: string = '',
        public telefone: string = '',
        public cpfCnpj: string = '',
        public redefinirCodigo: string = '',
        public senha: string = '',
        public senhaConfirmacao: string = '',
    ) { }
}